module.exports = __webpack_public_path__ + "img/brand-block-6.6d455976.png";